// extracted by mini-css-extract-plugin
export var buttons = "_an-0";
export var buttonsActive = "_an-h";
export var cancelConfirm = "_an-1";
export var closeButton = "_an-2";
export var column = "_an-3";
export var container = "_an-4";
export var detailHeader = "_an-6";
export var detailTitle = "_an-7";
export var detailsContent = "_an-5";
export var header = "_an-8";
export var headerWithClose = "_an-9";
export var icon = "_an-a";
export var infoIcon = "_an-c";
export var informationContainer = "_an-b";
export var sideDrawer = "_an-d";
export var sideDrawerOpen = "_an-e";
export var stickyFooter = "_an-f";
export var typeOption = "_an-g";